var _excluded = ["title", "children", "spacing", "variant"],
    _excluded2 = ["analyticsName"],
    _excluded3 = ["variant", "children", "analyticsName"];

function cov_2oyaww95a7() {
  var path = "/__w/code/code/js/packages/bricks/src/core/List/List.tsx";
  var hash = "84ea6f4f48a29aa0bf6eaecd78a409900f499e0a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/List/List.tsx",
    statementMap: {
      "0": {
        start: {
          line: 57,
          column: 87
        },
        end: {
          line: 87,
          column: 2
        }
      },
      "1": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 93
        }
      },
      "2": {
        start: {
          line: 63,
          column: 17
        },
        end: {
          line: 63,
          column: 84
        }
      },
      "3": {
        start: {
          line: 65,
          column: 19
        },
        end: {
          line: 65,
          column: 52
        }
      },
      "4": {
        start: {
          line: 66,
          column: 27
        },
        end: {
          line: 66,
          column: 47
        }
      },
      "5": {
        start: {
          line: 67,
          column: 18
        },
        end: {
          line: 67,
          column: 78
        }
      },
      "6": {
        start: {
          line: 68,
          column: 23
        },
        end: {
          line: 68,
          column: 69
        }
      },
      "7": {
        start: {
          line: 69,
          column: 34
        },
        end: {
          line: 69,
          column: 99
        }
      },
      "8": {
        start: {
          line: 71,
          column: 24
        },
        end: {
          line: 71,
          column: 63
        }
      },
      "9": {
        start: {
          line: 71,
          column: 38
        },
        end: {
          line: 71,
          column: 52
        }
      },
      "10": {
        start: {
          line: 73,
          column: 2
        },
        end: {
          line: 86,
          column: 4
        }
      },
      "11": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 107,
          column: 2
        }
      },
      "12": {
        start: {
          line: 92,
          column: 29
        },
        end: {
          line: 92,
          column: 51
        }
      },
      "13": {
        start: {
          line: 93,
          column: 30
        },
        end: {
          line: 96,
          column: 4
        }
      },
      "14": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 104,
          column: 30
        }
      },
      "15": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 102,
          column: 5
        }
      },
      "16": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 101,
          column: 9
        }
      },
      "17": {
        start: {
          line: 105,
          column: 20
        },
        end: {
          line: 105,
          column: 48
        }
      },
      "18": {
        start: {
          line: 106,
          column: 2
        },
        end: {
          line: 106,
          column: 69
        }
      },
      "19": {
        start: {
          line: 109,
          column: 41
        },
        end: {
          line: 183,
          column: 1
        }
      },
      "20": {
        start: {
          line: 111,
          column: 30
        },
        end: {
          line: 160,
          column: 6
        }
      },
      "21": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 115,
          column: 7
        }
      },
      "22": {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 114,
          column: 21
        }
      },
      "23": {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 137,
          column: 7
        }
      },
      "24": {
        start: {
          line: 119,
          column: 21
        },
        end: {
          line: 119,
          column: 97
        }
      },
      "25": {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 125,
          column: 9
        }
      },
      "26": {
        start: {
          line: 124,
          column: 10
        },
        end: {
          line: 124,
          column: 23
        }
      },
      "27": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 129,
          column: 9
        }
      },
      "28": {
        start: {
          line: 128,
          column: 10
        },
        end: {
          line: 128,
          column: 98
        }
      },
      "29": {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 136,
          column: 11
        }
      },
      "30": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 149,
          column: 7
        }
      },
      "31": {
        start: {
          line: 141,
          column: 21
        },
        end: {
          line: 141,
          column: 92
        }
      },
      "32": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 146,
          column: 9
        }
      },
      "33": {
        start: {
          line: 145,
          column: 10
        },
        end: {
          line: 145,
          column: 23
        }
      },
      "34": {
        start: {
          line: 148,
          column: 8
        },
        end: {
          line: 148,
          column: 20
        }
      },
      "35": {
        start: {
          line: 152,
          column: 19
        },
        end: {
          line: 152,
          column: 86
        }
      },
      "36": {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 157,
          column: 7
        }
      },
      "37": {
        start: {
          line: 156,
          column: 8
        },
        end: {
          line: 156,
          column: 21
        }
      },
      "38": {
        start: {
          line: 159,
          column: 6
        },
        end: {
          line: 159,
          column: 18
        }
      },
      "39": {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 172,
          column: 5
        }
      },
      "40": {
        start: {
          line: 163,
          column: 6
        },
        end: {
          line: 171,
          column: 8
        }
      },
      "41": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 181,
          column: 6
        }
      },
      "42": {
        start: {
          line: 185,
          column: 24
        },
        end: {
          line: 191,
          column: 1
        }
      },
      "43": {
        start: {
          line: 186,
          column: 2
        },
        end: {
          line: 190,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 77
          },
          end: {
            line: 87,
            column: 1
          }
        },
        line: 60
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 71,
            column: 32
          },
          end: {
            line: 71,
            column: 33
          }
        },
        loc: {
          start: {
            line: 71,
            column: 38
          },
          end: {
            line: 71,
            column: 52
          }
        },
        line: 71
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 91,
            column: 49
          },
          end: {
            line: 91,
            column: 50
          }
        },
        loc: {
          start: {
            line: 91,
            column: 87
          },
          end: {
            line: 107,
            column: 1
          }
        },
        line: 91
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 97,
            column: 12
          },
          end: {
            line: 97,
            column: 13
          }
        },
        loc: {
          start: {
            line: 97,
            column: 18
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 97
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 110,
            column: 2
          },
          end: {
            line: 110,
            column: 3
          }
        },
        loc: {
          start: {
            line: 110,
            column: 59
          },
          end: {
            line: 182,
            column: 3
          }
        },
        line: 110
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 111,
            column: 59
          },
          end: {
            line: 111,
            column: 60
          }
        },
        loc: {
          start: {
            line: 111,
            column: 70
          },
          end: {
            line: 160,
            column: 5
          }
        },
        line: 111
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 185,
            column: 24
          },
          end: {
            line: 185,
            column: 25
          }
        },
        loc: {
          start: {
            line: 185,
            column: 97
          },
          end: {
            line: 191,
            column: 1
          }
        },
        line: 185
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 55
          },
          end: {
            line: 62,
            column: 88
          }
        }, {
          start: {
            line: 62,
            column: 91
          },
          end: {
            line: 62,
            column: 93
          }
        }],
        line: 62
      },
      "1": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 27
          }
        }, {
          start: {
            line: 62,
            column: 31
          },
          end: {
            line: 62,
            column: 52
          }
        }],
        line: 62
      },
      "2": {
        loc: {
          start: {
            line: 66,
            column: 27
          },
          end: {
            line: 66,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 27
          },
          end: {
            line: 66,
            column: 42
          }
        }, {
          start: {
            line: 66,
            column: 46
          },
          end: {
            line: 66,
            column: 47
          }
        }],
        line: 66
      },
      "3": {
        loc: {
          start: {
            line: 67,
            column: 18
          },
          end: {
            line: 67,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 44
          },
          end: {
            line: 67,
            column: 60
          }
        }, {
          start: {
            line: 67,
            column: 63
          },
          end: {
            line: 67,
            column: 78
          }
        }],
        line: 67
      },
      "4": {
        loc: {
          start: {
            line: 68,
            column: 23
          },
          end: {
            line: 68,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 33
          },
          end: {
            line: 68,
            column: 64
          }
        }, {
          start: {
            line: 68,
            column: 67
          },
          end: {
            line: 68,
            column: 69
          }
        }],
        line: 68
      },
      "5": {
        loc: {
          start: {
            line: 69,
            column: 34
          },
          end: {
            line: 69,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 88
          },
          end: {
            line: 69,
            column: 92
          }
        }, {
          start: {
            line: 69,
            column: 95
          },
          end: {
            line: 69,
            column: 99
          }
        }],
        line: 69
      },
      "6": {
        loc: {
          start: {
            line: 75,
            column: 7
          },
          end: {
            line: 75,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 7
          },
          end: {
            line: 75,
            column: 12
          }
        }, {
          start: {
            line: 75,
            column: 16
          },
          end: {
            line: 75,
            column: 57
          }
        }],
        line: 75
      },
      "7": {
        loc: {
          start: {
            line: 77,
            column: 39
          },
          end: {
            line: 77,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 77,
            column: 57
          },
          end: {
            line: 77,
            column: 76
          }
        }, {
          start: {
            line: 77,
            column: 79
          },
          end: {
            line: 77,
            column: 81
          }
        }],
        line: 77
      },
      "8": {
        loc: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 98
      },
      "9": {
        loc: {
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 115,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 115,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 113
      },
      "10": {
        loc: {
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 118
      },
      "11": {
        loc: {
          start: {
            line: 121,
            column: 8
          },
          end: {
            line: 125,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 8
          },
          end: {
            line: 125,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 121
      },
      "12": {
        loc: {
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 129,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 129,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 127
      },
      "13": {
        loc: {
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 41
          }
        }, {
          start: {
            line: 127,
            column: 45
          },
          end: {
            line: 127,
            column: 79
          }
        }],
        line: 127
      },
      "14": {
        loc: {
          start: {
            line: 134,
            column: 25
          },
          end: {
            line: 134,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 25
          },
          end: {
            line: 134,
            column: 38
          }
        }, {
          start: {
            line: 134,
            column: 42
          },
          end: {
            line: 134,
            column: 60
          }
        }],
        line: 134
      },
      "15": {
        loc: {
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 149,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 149,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 140
      },
      "16": {
        loc: {
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 146,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 146,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 142
      },
      "17": {
        loc: {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 157,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 157,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 153
      },
      "18": {
        loc: {
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 162
      },
      "19": {
        loc: {
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 162,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 162,
            column: 31
          }
        }, {
          start: {
            line: 162,
            column: 35
          },
          end: {
            line: 162,
            column: 62
          }
        }],
        line: 162
      },
      "20": {
        loc: {
          start: {
            line: 187,
            column: 16
          },
          end: {
            line: 187,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 187,
            column: 16
          },
          end: {
            line: 187,
            column: 30
          }
        }, {
          start: {
            line: 187,
            column: 34
          },
          end: {
            line: 187,
            column: 47
          }
        }],
        line: 187
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "84ea6f4f48a29aa0bf6eaecd78a409900f499e0a"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2oyaww95a7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2oyaww95a7();

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import { bricks } from '../../system/bricks.types';
import { useMultiStyleConfig } from '../../system/utils';
import Box from '../Box';
import { Text } from '../Text';
import { forwardRef } from '@chakra-ui/system';
import { AccordionListItem } from './AccordionListItem';
import { ListItem } from './ListItem';
import { CardListItem } from './CardListItem';
import Checkmark from '../Icon/SpritesheetIcons/Checkmark';
import { useObservabilitySafe } from '../../hooks/useObservabilitySafe';
import { useMergeRefs } from '@chakra-ui/hooks';
var BaseList = (cov_2oyaww95a7().s[0]++, forwardRef(function (_ref, ref) {
  var _ref2;

  var title = _ref.title,
      children = _ref.children,
      spacingOverride = _ref.spacing,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_2oyaww95a7().f[0]++;
  var dataURIProps = (cov_2oyaww95a7().s[1]++, (cov_2oyaww95a7().b[1][0]++, variant === 'checklist') && (cov_2oyaww95a7().b[1][1]++, 'customIcon' in props) ? (cov_2oyaww95a7().b[0][0]++, getDataURIProps(props.customIcon)) : (cov_2oyaww95a7().b[0][1]++, {}));
  var styles = (cov_2oyaww95a7().s[2]++, useMultiStyleConfig('List', _objectSpread(_objectSpread({
    variant: variant
  }, props), dataURIProps))); // Selector applies style to all list item children EXCEPT the first one

  var selector = (cov_2oyaww95a7().s[3]++, '& > *:not(style) ~ *:not(style)');
  var accordionSpacing = (cov_2oyaww95a7().s[4]++, (_ref2 = (cov_2oyaww95a7().b[2][0]++, spacingOverride)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2oyaww95a7().b[2][1]++, 3));
  var spacing = (cov_2oyaww95a7().s[5]++, variant === 'accordion' ? (cov_2oyaww95a7().b[3][0]++, accordionSpacing) : (cov_2oyaww95a7().b[3][1]++, spacingOverride));
  var spacingStyle = (cov_2oyaww95a7().s[6]++, spacing ? (cov_2oyaww95a7().b[4][0]++, _defineProperty({}, selector, {
    mt: spacing
  })) : (cov_2oyaww95a7().b[4][1]++, {}));
  var asProp = (cov_2oyaww95a7().s[7]++, ['numbered', 'decimal'].includes(variant) ? (cov_2oyaww95a7().b[5][0]++, 'ol') : (cov_2oyaww95a7().b[5][1]++, 'ul')); // Determines whether or not List is an ordered or unordered list

  var ListComponent = (cov_2oyaww95a7().s[8]++, useMemo(function () {
    cov_2oyaww95a7().f[1]++;
    cov_2oyaww95a7().s[9]++;
    return bricks(asProp);
  }, [asProp]));
  cov_2oyaww95a7().s[10]++;
  return /*#__PURE__*/React.createElement(Box, {
    __css: styles.container
  }, (cov_2oyaww95a7().b[6][0]++, title) && (cov_2oyaww95a7().b[6][1]++, /*#__PURE__*/React.createElement(Text, {
    __css: styles.title
  }, title)), /*#__PURE__*/React.createElement(ListComponent, _extends({
    "data-testid": "list-".concat(variant).concat('size' in props ? (cov_2oyaww95a7().b[7][0]++, "-".concat(props['size'])) : (cov_2oyaww95a7().b[7][1]++, '')),
    ref: ref // __css has a lower priority than sx
    ,
    __css: _objectSpread(_objectSpread({}, styles.list), spacingStyle)
  }, props), children));
}));
var AccordionListWithTracking = (cov_2oyaww95a7().s[11]++, forwardRef(function (_ref4, ref) {
  var analyticsName = _ref4.analyticsName,
      props = _objectWithoutProperties(_ref4, _excluded2);

  cov_2oyaww95a7().f[2]++;

  var _ref5 = (cov_2oyaww95a7().s[12]++, useObservabilitySafe()),
      trackUserEvent = _ref5.trackUserEvent;

  var _ref6 = (cov_2oyaww95a7().s[13]++, useInView({
    threshold: 1,
    skip: !analyticsName
  })),
      _ref7 = _slicedToArray(_ref6, 2),
      inViewRef = _ref7[0],
      inView = _ref7[1];

  cov_2oyaww95a7().s[14]++;
  useEffect(function () {
    cov_2oyaww95a7().f[3]++;
    cov_2oyaww95a7().s[15]++;

    if (inView) {
      cov_2oyaww95a7().b[8][0]++;
      cov_2oyaww95a7().s[16]++;
      trackUserEvent({
        accordionViewEvent: {
          targetName: analyticsName
        }
      });
    } else {
      cov_2oyaww95a7().b[8][1]++;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [inView, analyticsName]);
  var mergedRef = (cov_2oyaww95a7().s[17]++, useMergeRefs(ref, inViewRef));
  cov_2oyaww95a7().s[18]++;
  return /*#__PURE__*/React.createElement(BaseList, _extends({
    variant: "accordion",
    ref: mergedRef
  }, props));
}));
export var List = (cov_2oyaww95a7().s[19]++, forwardRef(function (_ref8, ref) {
  var variant = _ref8.variant,
      children = _ref8.children,
      analyticsName = _ref8.analyticsName,
      props = _objectWithoutProperties(_ref8, _excluded3);

  cov_2oyaww95a7().f[4]++;
  var validatedChildren = (cov_2oyaww95a7().s[20]++, React.Children.map(children, function (child) {
    cov_2oyaww95a7().f[5]++;
    cov_2oyaww95a7().s[21]++;

    // Checking isValidElement is the safe way and avoids a typescript error too.
    if (! /*#__PURE__*/React.isValidElement(child)) {
      cov_2oyaww95a7().b[9][0]++;
      cov_2oyaww95a7().s[22]++;
      return child;
    } else {
      cov_2oyaww95a7().b[9][1]++;
    } // Validate accordion list variant only has AccordionListItem children


    cov_2oyaww95a7().s[23]++;

    if (variant === 'accordion') {
      var _ref9;

      cov_2oyaww95a7().b[10][0]++;

      var _item = (cov_2oyaww95a7().s[24]++, child);

      cov_2oyaww95a7().s[25]++;

      if (_item.type !== AccordionListItem) {
        cov_2oyaww95a7().b[11][0]++;
        cov_2oyaww95a7().s[26]++;
        // eslint-disable-next-line no-console
        // console.error('Accordion lists should only contain AccordionListItem children');
        return child;
      } else {
        cov_2oyaww95a7().b[11][1]++;
      }

      cov_2oyaww95a7().s[27]++;

      if ((cov_2oyaww95a7().b[13][0]++, _item.props.size === 'compact') && (cov_2oyaww95a7().b[13][1]++, _item.props.variant !== 'secondary')) {
        cov_2oyaww95a7().b[12][0]++;
        cov_2oyaww95a7().s[28]++;
        throw new Error('Compact sizes are only supported on secondary variant accordion list');
      } else {
        cov_2oyaww95a7().b[12][1]++;
      } // Injects analyticsName and padding into children when variant is accordion


      cov_2oyaww95a7().s[29]++;
      return /*#__PURE__*/React.cloneElement(_item, {
        noPadding: props.size === 'compact',
        analyticsName: (_ref9 = (cov_2oyaww95a7().b[14][0]++, analyticsName)) !== null && _ref9 !== void 0 ? _ref9 : (cov_2oyaww95a7().b[14][1]++, _item.props.panelId),
        boxShadow: props.boxShadow
      });
    } else {
      cov_2oyaww95a7().b[10][1]++;
    } // Validate card list variant only has CardListItem children


    cov_2oyaww95a7().s[30]++;

    if (variant === 'card') {
      cov_2oyaww95a7().b[15][0]++;

      var _item2 = (cov_2oyaww95a7().s[31]++, child);

      cov_2oyaww95a7().s[32]++;

      if (_item2.type !== CardListItem) {
        cov_2oyaww95a7().b[16][0]++;
        cov_2oyaww95a7().s[33]++;
        // eslint-disable-next-line no-console
        // console.error('Card lists should only contain CardListItem children');
        return child;
      } else {
        cov_2oyaww95a7().b[16][1]++;
      }

      cov_2oyaww95a7().s[34]++;
      return _item2;
    } else {
      cov_2oyaww95a7().b[15][1]++;
    } // Validate all other list variants only have ListItem children


    var item = (cov_2oyaww95a7().s[35]++, child);
    cov_2oyaww95a7().s[36]++;

    if (item.type !== ListItem) {
      cov_2oyaww95a7().b[17][0]++;
      cov_2oyaww95a7().s[37]++;
      // eslint-disable-next-line no-console
      // console.error('Lists should only contain ListItem children');
      return child;
    } else {
      cov_2oyaww95a7().b[17][1]++;
    }

    cov_2oyaww95a7().s[38]++;
    return item;
  }));
  cov_2oyaww95a7().s[39]++;

  if ((cov_2oyaww95a7().b[19][0]++, variant === 'accordion') && (cov_2oyaww95a7().b[19][1]++, analyticsName !== undefined)) {
    cov_2oyaww95a7().b[18][0]++;
    cov_2oyaww95a7().s[40]++;
    return /*#__PURE__*/React.createElement(AccordionListWithTracking, _extends({
      ref: ref // eslint-disable-next-line react/no-children-prop
      ,
      children: validatedChildren,
      analyticsName: analyticsName
    }, props));
  } else {
    cov_2oyaww95a7().b[18][1]++;
  }

  cov_2oyaww95a7().s[41]++;
  return /*#__PURE__*/React.createElement(BaseList // eslint-disable-next-line react/no-children-prop
  , _extends({
    children: validatedChildren,
    ref: ref,
    variant: variant
  }, props));
}));
cov_2oyaww95a7().s[42]++;

var getDataURIProps = function getDataURIProps(customIcon) {
  var _ref10;

  cov_2oyaww95a7().f[6]++;
  cov_2oyaww95a7().s[43]++;
  return {
    dataURISVG: (_ref10 = (cov_2oyaww95a7().b[20][0]++, customIcon.svg)) !== null && _ref10 !== void 0 ? _ref10 : (cov_2oyaww95a7().b[20][1]++, Checkmark.svg),
    dataURISVGColor: customIcon === null || customIcon === void 0 ? void 0 : customIcon.color,
    dataURISVGSize: customIcon === null || customIcon === void 0 ? void 0 : customIcon.size
  };
};